import React from 'react';
import { useTranslation } from '../../i18n';
import { AppIcon } from './icons';

interface GamePremiumBadgeProps {
  isMonthlyFree?: boolean;
  onPremiumClick?: () => void;
}

export const GamePremiumBadge: React.FC<GamePremiumBadgeProps> = ({
  isMonthlyFree = false,
  onPremiumClick,
}) => {
  const { t } = useTranslation();

  if (isMonthlyFree) {
    return (
      <span
        className="game-premium-badge game-premium-badge--monthly-free"
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          zIndex: 10,
          backgroundColor: 'var(--color-primary)',
          color: '#000',
          borderRadius: '12px',
          padding: '4px 10px',
          fontSize: '0.7rem',
          fontWeight: 'bold',
          boxShadow: '0 2px 8px rgba(var(--color-primary-rgb), 0.5)',
          whiteSpace: 'normal',
          textAlign: 'center',
          lineHeight: 1.2,
          maxWidth: '9.5rem',
          pointerEvents: 'none',
        }}
      >
        {t('common.premiumBadge.freeThisMonth')}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onPremiumClick?.();
      }}
      className="game-premium-badge"
      style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        zIndex: 10,
        backgroundColor: 'var(--color-primary)',
        color: '#000',
        border: 'none',
        borderRadius: '12px',
        padding: '4px 10px',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(var(--color-primary-rgb), 0.4)',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = '0.9';
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(var(--color-primary-rgb), 0.6)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '1';
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(var(--color-primary-rgb), 0.4)';
      }}
    >
      <AppIcon name="premium" fontSize="inherit" />
      <span>{t('common.premiumBadge.premium')}</span>
    </button>
  );
};
